<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div class="delivery-provider">
  <div class="delivery-provider__header">
    <div class="delivery-provider__header__back">
      <button
        class="delivery-provider__header__back__back-button"
        id="go-back-button"
        (click)="onGoBack()"
      >
        <span class="delivery-provider__header__back__back-button__back-icon material-icons">
          chevron_left
        </span>
      </button>
    </div>
    <div class="delivery-provider__header__title">{{ title | translate }}</div>
    <div class="delivery-provider__header__indicator">
      <frodo-connection-indicator></frodo-connection-indicator>
    </div>
  </div>
  <div class="delivery-provider__providers-container">
    <div class="delivery-provider__providers-container__arrow"></div>
    <div class="delivery-provider__providers">
      <button
        class="delivery-provider__providers__item"
        [ngClass]="{
          'delivery-provider__providers__item__selected': provider.selected
        }"
        *ngFor="let provider of providers"
        type="button"
        (click)="onProviderSelected(provider)"
      >
        <div class="delivery-provider__providers__content">
          <ng-container *ngIf="provider.logo">
            <img
              [src]="provider.logo"
              [alt]="provider.label"
              class="delivery-provider__providers__logo"
            />
          </ng-container>
          <span class="delivery-provider__providers__label">
            {{ provider.label }}
          </span>
        </div>
      </button>
    </div>
    <div class="delivery-provider__providers-container__arrow"></div>
  </div>
  <div class="delivery-provider__button-container">
    <button
      class="delivery-provider__button"
      (click)="onContinue()"
      [disabled]="isLoading || !isContinueEnabled"
      [ngClass]="{ 'delivery-provider__button__disabled': isLoading || !isContinueEnabled }"
    >
      {{ button | translate }}
    </button>
  </div>
  <div class="delivery-provider__logo">
    <frodo-logo [src]="logo" [alt]="'logo'"></frodo-logo>
  </div>
</div>
